import { Switch as AntSwitch } from 'antd'
import type { SwitchProps } from 'antd'
import type { ReactNode } from 'react'
import './style.scss'

export type UiSwitchProps = SwitchProps & {
  /** Nhãn hiển thị sau công tắc (giống `<UiCheckbox>Nhãn</UiCheckbox>`). Bấm vào nhãn cũng bật/tắt. */
  children?: ReactNode
}

// Wrapper Switch: bọc AntD Switch để features/pages không import trực tiếp 'antd'
// (hard-rule module-authoring #1). Không có children → pass-through như cũ.
export default function UiSwitch({ children, ...rest }: UiSwitchProps) {
  if (children === undefined || children === null || children === false) {
    return <AntSwitch {...rest} />
  }
  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: AntD Switch render <button> (labelable), biome không nhận ra
    <label className="ui-switch-field">
      <AntSwitch {...rest} />
      <span>{children}</span>
    </label>
  )
}
